import { useIntl } from 'react-intl';
import { NextSeo } from 'next-seo';
import * as React from 'react';
import { useRouter } from 'next/router';
import { styled } from '../../stitches.config';
import Head from 'next/head';
import Typography from '@/components/sushi/Typography';
import { TextShadowH1 } from '@/components/TextShadow/TextShadow';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import { Calculator } from '@/components/BudgetCalculator/Calculator';
import { SeoContent } from '@/components/BudgetCalculator/SeoContent';

const BudgetCalculator = () => {
  const { formatMessage } = useIntl();
  const router = useRouter();

  return (
    <>
      <NextSeo
        title={formatMessage({ id: 'budget_calculator.meta.title' })}
        description={formatMessage({ id: 'budget_calculator.meta.description' })}
        canonical={`${process.env.NEXT_PUBLIC_PUBLIC_PATH}/${router.locale}/tools/budget-calculator`}
        openGraph={{
          type: 'website',
          url: `${process.env.NEXT_PUBLIC_PUBLIC_PATH}/${router.asPath}/`,
          title: formatMessage({ id: 'budget_calculator.meta.title' }),
          description: formatMessage({ id: 'budget_calculator.meta.description' }),
          images: [
            {
              url: `${process.env.NEXT_PUBLIC_PUBLIC_PATH}/img/budget-calculator/${router.locale}/open-graph.png`,
              alt: formatMessage({ id: 'budget_calculator.meta.image_alt' }),
            },
          ],
        }}
      />
      <Header />
      <Wrapper id="home-wrapper">
        <Head>
          <meta
            name="twitter:title"
            content={formatMessage({ id: 'budget_calculator.meta.title' })}
          />
          <meta
            name="twitter:description"
            content={formatMessage({ id: 'budget_calculator.meta.twitter_card' })}
          />
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:image"
            content={`${process.env.NEXT_PUBLIC_PUBLIC_PATH}/img/budget-calculator/${router.locale}/open-graph.png`}
          />
        </Head>
        <Hero>
          <Title>
            <Typography variant="headingM" as={TextShadowH1} center>
              {formatMessage({ id: 'budget_calculator.title' })}
            </Typography>
            <Typography variant="bodyM" color="secondary" center font="montreal">
              {formatMessage({ id: 'budget_calculator.subtitle' })}
            </Typography>
          </Title>
          <Calculator />
        </Hero>
      </Wrapper>
      <SeoContent />
      <Footer bannerTitle="app.footer.bannerTitle" />
    </>
  );
};

export default BudgetCalculator;

const Wrapper = styled('div', {
  overflow: 'hidden auto',
  backgroundColor: '$colorGreyLv1',
  backgroundImage: 'url(/img/tools/budget_calculator_background.png)',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center top',
});

const Hero = styled('div', {
  paddingTop: '160px',
  textAlign: 'center',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: 'auto',
  '@sm': {
    paddingTop: '112px',
  },
});

const Title = styled('header', {
  padding: '0 32px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: 72,
  '> *:first-child': {
    marginBottom: '12px',
    '@sm': {
      marginBottom: '24px',
    },
  },
  '> *:not(:first-child)': {
    maxWidth: '900px',
  },
});
